// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container_28bu7"};